module.exports = "<ul (click)=\"focus()\">\n  <li class=\"tag\" *ngFor=\"let tag of tags; let i = index\">{{ tag }} <span class=\"icon-clear\" (click)=\"remove(i)\"></span></li>\n  <li class=\"tag nopadding\">\n    <input id=\"tagInput\"\n           [(ngModel)]=\"current\"\n           (keyup)=\"keyUp($event)\"\n           (blur)=\"blur()\" />\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tags/tags.component.html
// module id = ../../../../../src/app/shared/tags/tags.component.html
// module chunks = 2